import React, { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { shallowEqual, useDispatch } from 'react-redux';
import { actions as mainActions } from '@/modules/main';
import { useSelector } from 'react-redux';
import { AllState } from '@/state';

const Welcome: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pagePaths, menus } = useSelector(
    (state: AllState) => ({ pagePaths: state.main.pagePaths, menus: state.main.menus }),
    shallowEqual,
  );

  useEffect(() => {
    const firstPath = pagePaths?.[0];
    if (firstPath && menus?.length) {
      dispatch(mainActions.pushTabItem(firstPath));
      history.push(firstPath);
    }
  }, [pagePaths, menus]);

  return <></>;
};

export default Welcome;
